export const tierDisplayNames = {
  bronze: "Bronze Tier",
  gold: "Gold Tier",
  platinum: "Platinum Tier",
};

export const tierIcons = {
  bronze: "🥉",
  gold: "🥇",
  platinum: "💎",
};

export const getTierDisplayName = (tierKey: string) => {
  if (tierKey === "no-tier") return "No Tier";
  return tierDisplayNames[tierKey as keyof typeof tierDisplayNames] || tierKey;
};